import { NgModule } from '@angular/core'
import { SearchPipe } from 'shared/pipes/search.pipe'

@NgModule({
	declarations: [SearchPipe],
	exports: [SearchPipe],
})
export class SearchPipeModule {}
